<trato-loading [loading]="loading$ | async" [config]="loadingConfig"></trato-loading>